import type { RefObject } from 'react';
import { useSearchableListKeyboardNavigation } from 'components/ui/hooks';

interface UseAuthSelectorKeyboardNavigationOptions {
  inputRef?: RefObject<HTMLInputElement | null>;
  listRef: RefObject<HTMLElement | null>;
}

const useAuthSelectorKeyboardNavigation = ({
  inputRef,
  listRef,
}: UseAuthSelectorKeyboardNavigationOptions) => {
  // Auth selectors render workspace options as links, not MUI MenuItems. Keep this hook Auth-owned
  // so it can preserve link semantics and the Escape-to-search behavior from the sign-in flow.
  const {
    focusFirstItem: focusFirstOption,
    handleItemsKeyDown: handleOptionsKeyDown,
    handleSearchKeyDown,
  } = useSearchableListKeyboardNavigation<HTMLAnchorElement>({
    inputRef,
    itemSelector: 'a[href]',
    listRef,
  });

  return {
    focusFirstOption,
    handleOptionsKeyDown,
    handleSearchKeyDown,
  };
};

export default useAuthSelectorKeyboardNavigation;
